import {Button, Container, Grid, Icon, MenuItem, TextField} from "@mui/material";
import {makeStyles, withStyles} from "@mui/styles";
import React, {useEffect, useRef} from "react";
import clsx from "clsx";
import Typography from "@mui/material/Typography";
import ReCAPTCHA from "react-google-recaptcha";

const NautilusTextInput = withStyles({
    root: {
        backgroundColor: 'white',
        '& .MuiInputBase-input': {
            fontSize: '1.2rem',
            height: '2em',
        },
        '& .MuiFormLabel-root': {
            fontSize: '1.2rem',
        },
        '& label.Mui-focused': {
            color: '#1ebce7',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#1ebce7',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            // '& fieldset': {
            //     borderColor: 'red',
            // },
            '&:hover fieldset': {
                borderColor: '#1ebce7',
            },
            '&.Mui-focused': {
                '& fieldset': {
                    borderColor: '#1ebce7',
                    '& legend': {
                        padding: '3px'
                    }
                }
            },
            '&.Mui-focused .MuiSelect-select fieldset': {
                '& legend': {
                    padding: '0'
                }
            },
        },
    },
})(TextField);
const useStyles = makeStyles((theme) => ({
    button: {
        lineHeight: 2.5,
        fontSize: '1.4rem',
        backgroundColor: '#00b7f0',
        borderColor: '#00b7f0',
    },
    root: {
        '& .MuiPaper-elevation1': {
            boxShadow: 'none'
        }
    }
}));

export default function InquiryForm({setInquiry, inquiryData, submitInquiry, selectedRooms, trip}) {
    const recaptchaRef = useRef();
    const classes = useStyles();
    const handleForm = (event) => {
        setInquiry(event);
    }
    const handleSubmit = async (event) => {
        event.preventDefault();
        const token = await recaptchaRef.current.executeAsync();
        submitInquiry();
    }
    const boatTrip = parseInt(trip['location']['tripTypeFk']) === 1;
    return (
        <Container maxWidth={'lg'} style={{minWidth: 350, paddingLeft: 0, paddingRight: 0}} className={classes.root}>
            <Typography variant="h3" component="h3" className={'tripTitle'} sx={{paddingBottom: 5}}>
                Inquiry Request
            </Typography>
            <form className={'formPayment'} noValidate onSubmit={handleSubmit}>
                <Grid container direction="row" justify="center" alignItems="center" style={{paddingBottom: 30}}>
                    <Grid item xs={6} md={6} style={{padding: 5}}>
                        <NautilusTextInput fullWidth name="firstname" value={inquiryData['firstname']}
                                           onChange={handleForm} label="First Name" variant="outlined"/>
                    </Grid>
                    <Grid item xs={6} md={6} style={{padding: 5}}>
                        <NautilusTextInput fullWidth name="lastname" value={inquiryData['lastname']}
                                           onChange={handleForm} label="Last Name" variant="outlined"/>
                    </Grid>
                    <Grid item xs={6} md={4} style={{padding: 5,}}>
                        <NautilusTextInput fullWidth name="email" value={inquiryData['email']} onChange={handleForm}
                                           label="Email Address" variant="outlined"/>
                    </Grid>
                    <Grid item xs={6} md={4} style={{padding: 5}}>
                        <NautilusTextInput fullWidth name="phone" value={inquiryData['phone']} onChange={handleForm}
                                           label="Phone" variant="outlined"/>
                    </Grid>
                    <Grid item xs={6} md={4} style={{padding: 5}}>
                        <NautilusTextInput fullWidth name="guests" value={inquiryData['guests']} onChange={handleForm}
                                           label="Number of Guests" variant="outlined"/>
                    </Grid>
                    <Grid item xs={12} md={6} style={{padding: 5}}>
                        <NautilusTextInput fullWidth name="inquiryType" value={inquiryData['inquiryType']}
                                           variant="outlined" select label="Inquire About"
                                           onChange={handleForm}>
                            <MenuItem value={''}>
                                Inquire About
                            </MenuItem>
                            {boatTrip && <MenuItem value={"Half Boat Charter"}>Half Boat Charter</MenuItem>}
                            {boatTrip && <MenuItem value={"Whole Boat Charter"}>Whole Boat Charter</MenuItem>}
                            {selectedRooms && selectedRooms.length > 0 && selectedRooms.map((room, index) => (
                                <MenuItem key={index} value={room.title}><span dangerouslySetInnerHTML={{__html: room.title}}/></MenuItem>
                            ))}

                        </NautilusTextInput>
                    </Grid>
                    <Grid item xs={12} md={6} style={{padding: 5}}>
                        <NautilusTextInput fullWidth name="interest" value={inquiryData['interest']} variant="outlined"
                                           select label="I am interested in"
                                           onChange={handleForm}>
                            <MenuItem value={''}>
                                I am interested in
                            </MenuItem>
                            <MenuItem value={"This Trip Only"}>This Trip Only</MenuItem>
                            <MenuItem value={"Any Trip This Month"}>Any Trip This Month</MenuItem>
                            <MenuItem value={"Any Costa Rica Trip"}>Any Costa Rica Trip</MenuItem>
                            <MenuItem value={"Any Socorro Trip"}>Any Socorro Trip</MenuItem>
                            <MenuItem value={"Any Sea of Cortez Trip"}>Any Sea of Cortez Trip</MenuItem>

                        </NautilusTextInput>
                    </Grid>
                    <Grid item xs={12} style={{padding: 5}}>
                        <NautilusTextInput fullWidth name="comments" value={inquiryData['comments']}
                                           placeholder={'Comments, Notes, Requests'} onChange={handleForm} multiline
                                           rows={4} label="Comments, Notes, Requests" variant="outlined"/>
                    </Grid>
                    <Grid item xs={12} style={{padding: 5}}>
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={window.recaptchaKey}
                            size="invisible"
                        />
                    </Grid>
                    <Grid item xs={12} style={{padding: 5}}>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            fullWidth
                            className={clsx({[classes.button]: true, 'payButton': true})}
                            startIcon={<Icon>send</Icon>}
                        >
                            Submit Inquiry
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Container>
    );
}